import {AdditionalStudents, PaymentPeriod, TariffsSelectedValues} from "./types";

export const defaultTariffValues: TariffsSelectedValues = {
  paymentPeriod: PaymentPeriod.MonthEnd,
  students: 10,
  autoRenewal: false,
  additionalStudents: null,
  storage: 5,
  prices: {
    students: 0,
    storage: 0,
    full: 0 ,
  },
}

/**
 * function return students cost by students count
 * @param {number | AdditionalStudents} count
 * @return {number}
 */
export function getStudentsCost(count: number | AdditionalStudents) {
  switch (count) {
    case 10: return 0;
    case 20: return 957;
    case 30: return 1401;
    case 40: return 1823;
    case 50: return 2225;
    case 60: return 2606;
    case 70: return 2968;
    case 80: return 3312;
    case 90: return 3637;
    case 100: return 3953;
    case 110: return 4254;
    case 120: return 4539;
    case 130: return 4810;
    case 140: return 5067;
    case 150: return 5311;
    case 160: return 5541;
    case 170: return 5759;
    case 180: return 5965;
    case 190: return 6159;
    case 200: return 6355;
    case 210: return 6541;
    case 220: return 6717;
    case 230: return 6883;
    case 240: return 7040;
    case 250: return 7188;
    case 260: return 7328;
    case 270: return 7459;
    case 280: return 7582;
    case 290: return 7697;
    case 300: return 7821;
    case 310: return 7938;
    case 320: return 8048;
    case 330: return 8152;
    case 340: return 8249;
    case 350: return 8341;
    case 360: return 8426;
    case 370: return 8506;
    case 380: return 8581;
    case 390: return 8650;
    case 400: return 8731;
    case 410: return 8808;
    case 420: return 8880;
    case 430: return 8948;
    case 440: return 9012;
    case 450: return 9071;
    case 460: return 9126;
    case 470: return 9177;
    case 480: return 9224;
    case 490: return 9267;
    case 500: return 9326;
    case 510: return 9381;
    case 520: return 9433;
    case 530: return 9482;
    case 540: return 9528;
    case 550: return 9570;
    case 560: return 9610;
    case 570: return 9646;
    case 580: return 9680;
    case 590: return 9711;
    case 600: return 9759;
    case 610: return 9805;
    case 620: return 9848;
    case 630: return 9889;
    case 640: return 9927;
    case 650: return 9963;
    case 660: return 9997;
    case 670: return 10029;
    case 680: return 10058;
    case 690: return 10086;
    case 700: return 10132;
    case 710: return 10176;
    case 720: return 10218;
    case 730: return 10258;
    case 740: return 10297;
    case 750: return 10334;
    case 760: return 10369;
    case 770: return 10402;
    case 780: return 10434;
    case 790: return 10464;
    case 800: return 10514;
    case 810: return 10563;
    case 820: return 10610;
    case 830: return 10655;
    case 840: return 10700;
    case 850: return 10742;
    case 860: return 10784;
    case 870: return 10824;
    case 880: return 10863;
    case 890: return 10901;
    case 900: return 10960;
    case 910: return 11017;
    case 920: return 11074;
    case 930: return 11129;
    case 940: return 11184;
    case 950: return 11237;
    case 960: return 11289;
    case 970: return 11341;
    case 980: return 11391;
    case 990: return 11441;
    case 1000: return 11490;
    case 2000: return 19900;
    case 3000: return 27500;
    case 4000: return 35900;
    case 5000: return 41900;
    case 'Unlimited': return 59900;
  }
}

/**
 * function return saved tariffs values or default values
 * @return {TariffsSelectedValues}
 */
export function getLocalStorageTariffs():TariffsSelectedValues {
  const fromStorage = localStorage.getItem('tariffs');
  const exist = fromStorage && JSON.parse(fromStorage);
  return exist || defaultTariffValues;
}


/**
 * function save tariffs to local storage
 * @return {void}
 */
export function setLocalStorageTariffs(values: TariffsSelectedValues):void {
  localStorage.setItem('tariffs', JSON.stringify(values))
}
